// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const form = "Form__form__XFgYc";
export const formFullWidth = "Form__formFullWidth__XKk0Q";
export const item = "Form__item__r4b4V";
export const nthFormColumn = "Form__nthFormColumn__UK+CJ";
export const submitItem = "Form__submitItem__2yjdq";
export const singleLineForm = "Form__singleLineForm__qcOPs";
export const singleLineFormInner = "Form__singleLineFormInner__dKqjW";
export const field = "Form__field__45uxh";
export const fieldHint = "Form__fieldHint__WJUhU font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const submitButtonWrapper = "Form__submitButtonWrapper__2cmfF";
export const submitButtonWrapperWide = "Form__submitButtonWrapperWide__u9kCC";
export const forgotPassword = "Form__forgotPassword__GbPD7 font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const mobileTitle = "Form__mobileTitle__masTH TransactionEditForm__title__4dnvO font-faces__atlasGroteskMedium__1ilbx font-faces__atlasGrotesk__rYPJr";
export const buttonRowWrapper = "Form__buttonRowWrapper__Q49yH";
export const checkboxWrapper = "Form__checkboxWrapper__Gmg-b";
export const onSettingsPage = "Form__onSettingsPage__LmJym";
export const cancelLinkWrapper = "Form__cancelLinkWrapper__kqGqQ";
export const formGeneralError = "Form__formGeneralError__JZSeI font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const formGeneralErrorLink = "Form__formGeneralErrorLink__9K9yM";
export const recaptchaOverlay = "Form__recaptchaOverlay__Muljb";
export const recaptchaPrivacyLink = "Form__recaptchaPrivacyLink__eratF";
export const recaptchaTermsLink = "Form__recaptchaTermsLink__ZhuDJ";
export const avatar = "Form__avatar__iUqqu";